import liff from "@line/liff";

let initPromise: Promise<boolean> | null = null;

// LIFFの初期化を1度だけ実行して使い回す。失敗しても例外は投げず false を返す
// (LIFFに依存しないページ=クイズを、チャネル未設定やLINE側の障害で壊さないため)
export function ensureLiffInit(): Promise<boolean> {
  if (!initPromise) {
    initPromise = liff
      .init({ liffId: process.env.REACT_APP_LIFF_ID || "" })
      .then(() => true)
      .catch((error) => {
        console.error("LIFF init failed:", error);
        initPromise = null;
        return false;
      });
  }
  return initPromise;
}
